import { hideAll } from 'tippy.js';

export const hideAllTooltips = () => hideAll();
